module.exports = __webpack_public_path__ + "img/img_blank_exchange@2x.814405dc.png";